<template>
  <Card>
    <CardArtwork @click="play"
                 :src="soundkit.image(300)"
                 :active="isActive">
      <PlayButton slot="center"
                  :playing="isPlaying" />
    </CardArtwork>
    <CardTitle :title="soundkit.name"
               :to="{name: 'soundkit', params: {soundkit: soundkit.id}}"
               :subtitle="!!soundkit.itemsCount ? `${soundkit.itemsCount} Files` : ''" />
    <CardBuyButton :item="soundkit" />
  </Card>
</template>

<script>
import Card from "../../base/base-card/BaseCard";
import CardArtwork from "../../base/base-artwork";
import CardTitle from "../../base/base-card/BaseCardTitle";
import CardBuyButton from "../../base/base-card/BaseCardBuyButton";
import PlayButton from "../../base/base-play";

export default {
  components: { CardBuyButton, CardTitle, PlayButton, CardArtwork, Card },
  props: {
    soundkit: {
      type: Object,
      required: true
    }
  },
  computed: {
    playerActive() {
      return this.$store.state.player.playing;
    },
    playlistManager() {
      return this.$store.state.playlistManager;
    },
    isPaused() {
      return (this.playlistManager.isPlaying(this.soundkit) && !this.playerActive);
    },
    isPlaying() {
      return (this.playlistManager.isPlaying(this.soundkit) && this.playerActive);
    },
    isActive() {
      return this.isPaused || this.isPlaying
    }
  },
  methods: {
    play() {
      if (this.isPlaying) {
        this.soundkit.pause();
      } else {
        this.soundkit.play();
      }
    }
  }
};
</script>
